export const linkTrustwallet = 'https://trustwallet.com/download';
export const linkContactUS = 'mailto:support@swipelux.com';
export const linkBuyCrypto = 'https://swipelux.com/buy.html';
export const tabletBreakpoint = '1150px';
export const mobileBreakpoint = '725px';

export const PHONE_QUERY_KEY = 'p';
